import { createGlobalStyle } from 'styled-components';

const CommonStyle = createGlobalStyle`
  .sprite {
  background-image: url(https://gos3.ibcdn.com/giCommonSprite-1638795480.png);
  background-size: 250px 250px;
  background-repeat: no-repeat;
  display: inline-block;
  flex-shrink: 0;
}

.greyCross--big{
	width: 19px;
	  height: 19px;
	background-position: -154px -6px;
}
.blankStar--big{
	width: 33px;
	height: 33px;
	background-position : -216px -3px;
}
.yellowStar--big{
	width: 33px;
	height: 33px;
	background-position : -182px -5px;
}
.blackCross{
	width: 14px;
	height: 14px;
	background-position : -131px -9px;
}
.playStoreIcon{
	width: 17px;
	height: 18px;
	background-position : -105px -5px;
}
.greyCross{
	width: 12px;
	height: 12px;
	background-position : -3px -6px;
}
.smileyIcon{
	width: 22px;
	height: 22px;
	background-position : -75px -4px;
}
.blankStar{
	width: 23px;
	height: 23px;
	background-position : -49px -2px;
}
.yellowStar{
	width: 23px;
	height: 23px;
	background-position : -23px -2px;
}
.rotatingCircle{
  width: 20px;
  height: 21px;
  background-position: -1px -118px;
  -webkit-animation:spin 1s linear infinite;
		-moz-animation:spin 1s linear infinite;
		animation:spin 1s linear infinite;

@-moz-keyframes spin{
	100%{
		-moz-transform:rotate(360deg);
	}
}
@-webkit-keyframes spin{
	100%{
		-webkit-transform:rotate(360deg);
	}
}
@keyframes spin{
	100%{
		-webkit-transform:rotate(360deg);
		transform:rotate(360deg);
	}
}
} 
.rotatingCircle--green{
  width: 19px;
	height: 20px;
  background-position: -64px -357px;
  -webkit-animation:spin 1s linear infinite;
		-moz-animation:spin 1s linear infinite;
		animation:spin 1s linear infinite;

@-moz-keyframes spin{
	100%{
		-moz-transform:rotate(360deg);
	}
}
@-webkit-keyframes spin{
	100%{
		-webkit-transform:rotate(360deg);
	}
}
@keyframes spin{
	100%{
		-webkit-transform:rotate(360deg);
		transform:rotate(360deg);
	}
} 
}
`;

export default CommonStyle;
